__turbopack_context__.v({
  "aboutQuoteWrapper": "AboutQuote-module-scss-module__igDZpW__aboutQuoteWrapper",
});
